import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import ErrorBoundary from '../../molecules/ErrorBoundary'
import FormattingProvider from '../../organisms/FormattingProvider'
import { useHideSideMenuEffect } from '../../../redux/slices/appContext'
import NotAvailable from '../../organisms/NotAvailable'
import { useIsDenaliLabsActive } from '../../../hooks/featureChecks'
import IndexView from './IndexView'
import NLQIndex from './NLQ'
import NLQ2Index from './NLQ2'
import AbundanceDesignerIndex from './AbundanceDesigner'
import PlaygroundView from './AbundanceDesigner/Playground'

const DenaliLabsIndex = () => {
  const { path } = useRouteMatch()
  useHideSideMenuEffect([])
  const isDenaliLabsActive = useIsDenaliLabsActive()

  if (!isDenaliLabsActive) {
    return <NotAvailable />
  }

  return (
    <ErrorBoundary name='Denali Labs'>
      <FormattingProvider>
        <Switch>
          <SecureRoute path={path} exact>
            <IndexView root={path} />
          </SecureRoute>
          <SecureRoute path={`${path}/nlq`}>
            <NLQIndex />
          </SecureRoute>
          <SecureRoute path={`${path}/nlq2`}>
            <NLQ2Index />
          </SecureRoute>
          <SecureRoute path={`${path}/abundance-designer`} exact>
            <AbundanceDesignerIndex />
          </SecureRoute>
          <SecureRoute path={`${path}/abundance-designer/playground`} exact>
            <PlaygroundView />
          </SecureRoute>
          <SecureRoute path={`${path}/abundance-designer/playground/:threadId`} exact>
            <PlaygroundView />
          </SecureRoute>
        </Switch>
      </FormattingProvider>
    </ErrorBoundary>
  )
}

export default DenaliLabsIndex
